class AddElementModalController {
    constructor($http, Env, $filter, seatplan, currentGroup, $uibModalInstance, showGroupSelection, hiddenElements, requiredPax, currentSelectedElementIds, isSingleSelect, bookingInformation, allowElementMultiSelection) {
        this.http = $http;
        this.env = Env;
        this.filter = $filter;
        this.seatplan = seatplan;
        this.currentGroup = currentGroup;
        this.modalInstance = $uibModalInstance;
        this.bookingInformation = bookingInformation || {};
        this.returnData = {};
        this.hiddenElements = hiddenElements;
        this.requiredPax = requiredPax;
        this.isSingleSelect = isSingleSelect;
        this.allowElementMultiSelection = !!allowElementMultiSelection

        this.objects = [];
        this.showGroupSelection = !!showGroupSelection;
        this.groups = this.seatplan.groups.data;

        this.prepareBlockedElements();

        this.resetSelected();
        this.selected.ids = currentSelectedElementIds;
        this.updatePaxCount();

        this.loading = false;
    }

    prepareBlockedElements() {

    }

    selectGroup(group) {
        this.currentGroup = group.id;
        this.resetSelected();
    }

    onSelectionChange(allElements) {
        this.resetSelected();
        if (!this.isSingleSelect || allElements.length === 1) {
            this.resetSelected();

            this.selected.objects = _.cloneDeep(allElements);
            _.each(this.selected.objects, (element) => {
                this.selected.ids.push(element.id);
            });

            this.updatePaxCount();
        } else if(this.isSingleSelect && allElements.length === 2) {
            this.selected.objects = [allElements[1]];
            this.selected.ids = [allElements[1].id];
        }

        // this.showGroupSelection = !(allElements.length > 0);
    }

    updatePaxCount() {
        let paxCount = 0;
        _.each(this.selected.objects, (element) => {
            paxCount += element.pax;
        });
        this.currentPax = paxCount;
    }

    takeSelected() {
        this.modalInstance.close({
            elements: this.selected.objects,
            group: this.currentGroup
        });
    }

    dismissModal() {
        this.modalInstance.dismiss();
    }

    resetSelected() {
        this.selected = {
            ids: [],
            objects: []
        };
    }
}

AddElementModalController.$inject = [
    '$http',
    'Env',
    '$filter',
    'seatplan',
    'currentGroup',
    '$uibModalInstance',
    'showGroupSelection',
    'hiddenElements',
    'requiredPax',
    'currentSelectedElementIds',
    'isSingleSelect',
    'bookingInformation',
    'allowElementMultiSelection'
];

/**
 * @ngdoc object
 * @name guestlists.controller:AddElementModalController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .controller('AddElementModalController', AddElementModalController);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/guestlists/seats/add-element-modal-controller.js